export const LOAD_TRANSACTIONS = 'LOAD_TRANSACTIONS';
export const SET_NEW_TRANSACTIONS = 'SET_NEW_TRANSACTIONS';
export const UPDATE_NEW_TRANSACTIONS = 'UPDATE_NEW_TRANSACTIONS';
export const SET_LAST_TRANSACTION = 'SET_LAST_TRANSACTION';
export const MARK_ACCOUNT_READ = 'MARK_ACCOUNT_READ';
export const LOAD_ACCOUNTS = 'LOAD_ACCOUNTS';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const LOAD_PAYEES = 'LOAD_PAYEES';
export const LOAD_BANKS = 'LOAD_BANKS';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_PREFS = 'SET_PREFS';
export const MERGE_LOCAL_PREFS = 'MERGE_LOCAL_PREFS';
export const MERGE_GLOBAL_PREFS = 'MERGE_GLOBAL_PREFS';
export const SET_BUDGETS = 'SET_BUDGETS';
export const SET_REMOTE_FILES = 'SET_REMOTE_FILES';
export const SET_ALL_FILES = 'SET_ALL_FILES';
export const SET_AVAILABLE_IMPORTS = 'SET_AVAILABLE_IMPORTS';
export const CLOSE_BUDGET = 'CLOSE_BUDGET';
export const SET_APP_STATE = 'SET_APP_STATE';
export const DEBUG_CELL = 'DEBUG_CELL';
export const PUSH_MODAL = 'PUSH_MODAL';
export const REPLACE_MODAL = 'REPLACE_MODAL';
export const HIDE_MODALS = 'HIDE_MODALS';
export const SHOW_MODALS = 'SHOW_MODALS';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const POP_MODAL = 'POP_MODAL';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const GET_USER_DATA = 'GET_USER_DATA';
export const SET_LAST_UNDO_STATE = 'SET_LAST_UNDO_STATE';
export const SET_LAST_SPLIT_STATE = 'SET_LAST_SPLIT_STATE';
export const SET_ACCOUNTS_SYNCING = 'SET_ACCOUNTS_SYNCING';
export const ACCOUNT_SYNC_STATUS = 'ACCOUNT_SYNC_STATUS';
export const ACCOUNT_SYNC_FAILURES = 'ACCOUNT_SYNC_FAILURES';
export const SIGN_OUT = 'SIGN_OUT';

export const SET_TUTORIAL_STAGE = 'SET_TUTORIAL_STAGE';
export const DEACTIVATE_TUTORIAL = 'DEACTIVATE_TUTORIAL';
